import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { search } from "../../services/thunks/ProductListThunks";
import { stat } from "fs";
import AdminThunk from "../../services/thunks/AdminThunk";
import { resetAllState } from "./resetAllState";
import genericUtility from "../../services/utility/GenericUtility";


export interface MakeOfferState {
  isMakeOfferOpen: boolean;
  productIdBeingViewed?: string;
}
// Example initial state for the UI database
const initialState = {
  isCreateProductOpen: false,
  isWipOpen: false,
  isAuthOpen: false,
  isHotspotBannerVisible: false,
  makeOfferState: {
    isMakeOfferOpen: false,
    productIdBeingViewed: "",
  },
  theme: "light", // Example: "light" or "dark"
  notifications: [], // Example: Array of notifications
  UserLocation: null as any,
  UserLocationName: "",
  searchRadius: 5000 as number,
  uiConfigurations: {} as any,
};

// Create a slice for the UI state
const generalSlice = createSlice({
  name: "generalDbDb",
  initialState,
  reducers: {
    toggleCreatePopup(state) {
      state.isCreateProductOpen = !state.isCreateProductOpen;
    },
    openWorkInProgress(state) {
      state.isWipOpen = true;
    },
    closeWorkInProgress(state) {
      state.isWipOpen = false;
    },
    setUserLocation(state, action) {
      state.UserLocation = action.payload;
    },
    setUserLocationName(state, action) {
      state.UserLocationName = action.payload;
    },
    setSearchRadius(state, action) {
      state.searchRadius = action.payload;
    },
    openAuth(state, action: PayloadAction<string | undefined>) {
      state.isAuthOpen = true;
      // Capture where the user was so they return there after logging in.
      // Prefer an explicit payload; otherwise fall back to the current location.
      const currentPath =
        action.payload ||
        (typeof window !== "undefined"
          ? window.location.pathname + window.location.search
          : "");
      // Don't store auth-only routes — returning there would be pointless.
      const isAuthRoute = /^\/(login|signup|welcome|validateuser)/.test(
        currentPath
      );
      if (currentPath && !isAuthRoute) {
        genericUtility.setReturnUrl(currentPath);
      }
    },
    closeAuth(state) {
      state.isAuthOpen = false;
      genericUtility.clearReturnUrl();
    },
    openMakeOffer(state) {
      state.makeOfferState.isMakeOfferOpen = true;
    },
    closeMakeOffer(state) {
      state.makeOfferState.isMakeOfferOpen = false;
    },
    setProductBeingViewed(state, action) {
      state.makeOfferState.productIdBeingViewed = action.payload;
    },
    setHotspotBannerVisible(state, action: PayloadAction<boolean>) {
      // If we are trying to show it, check if it was previously dismissed
      if (action.payload === true) {
        const isDismissed = localStorage.getItem("hotspot_banner_dismissed") === "true";
        if (isDismissed) return;
      }
      state.isHotspotBannerVisible = action.payload;
    },
    hideHotspotBanner(state) {
      state.isHotspotBannerVisible = false;
      // Persist the dismissal
      localStorage.setItem("hotspot_banner_dismissed", "true");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AdminThunk.fetchUiConfigurations.pending, (state) => { })
      .addCase(AdminThunk.fetchUiConfigurations.fulfilled, (state, action) => {
        const map: Record<string, any> = {};

        action.payload?.forEach((item: any) => {
          map[item.configName] = item;
        });

        state.uiConfigurations = map;
      })
      .addCase(
        AdminThunk.fetchUiConfigurations.rejected,
        (state, action) => { }
      )
      .addCase(resetAllState, () => initialState);
  },
});

export const {
  toggleCreatePopup,
  openWorkInProgress,
  closeWorkInProgress,
  setUserLocation,
  setSearchRadius,
  openAuth,
  closeAuth,
  openMakeOffer,
  closeMakeOffer,
  setProductBeingViewed,
  setUserLocationName,
  setHotspotBannerVisible,
  hideHotspotBanner,
} = generalSlice.actions;

export default generalSlice.reducer;
